export default __webpack_public_path__ + "static/ios-case-2-11d3d0f348eff72aa5bb6371607206fd.webp";